import { Nomination, NominationRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createNomination: (
  fetchContext: FetchContext,
  nomination: Nomination,
  accessToken?: string,
) => Promise<NominationRef> = (fetchContext, nomination, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations`, {
    method: 'POST',
    body: JSON.stringify(nomination),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationRef>(fetchContext.errorStore, response, 'create nomination'));
